import * as Yup from 'yup';

export const validationSchema = Yup.object({
  phase: Yup.object({
    label: Yup.string(),
    value: Yup.string(),
  })
    .required('Required')
    .nullable(),
  deliverable: Yup.object({
    label: Yup.string(),
    value: Yup.string(),
    dueDate: Yup.string(),
  })
    .required('Required')
    .nullable(),
  dueDate: Yup.string(),
  proposedDueDate: Yup.string().required('Required'),
  responseDueBy: Yup.string().required('Required'),
  notes: Yup.string().required('Required'),
  reason: Yup.string().required('Required'),
  noResponseConsequence: Yup.string().required('Required'),
  changeInDays: Yup.number(),
  templateDocuments: Yup.array(),
  recentFiles: Yup.array(),
});

export type DeliverableChangeOrderSchema = Yup.InferType<typeof validationSchema>;
